export const IS_DEV = import.meta.env.DEV;
export const IS_TEST = import.meta.env.MODE === 'test';

export const QUOIDEN_SUPPORT_EMAIL = 'support@quoiden.com';

export enum LocalStorageKeys {
  StoredId = 'storedId',
  InvitationToken = 'invitationToken',
  InvitationDecision = 'invitationDecision',
}

export const STORAGE_TYPES = {
  LOCAL: 'localStorage',
  SESSION: 'sessionStorage',
} as const;

export const CARD_WIDTH = 176;
export const CARD_HEIGHT = 160;
export const EDGE_VERTICAL_GAP = 40;
export const EDGE_RADIUS_MAX = 16;

/**
 * Logging and Sentry related constants
 */
export const SENTRY_OPERATIONS = {
  APOLLO_GET_ACCESS_TOKEN: 'apollo.getAccessToken',
  BROWSER_STORAGE_GET_SNAPSHOT: 'browserStorage.getSnapshot',
  BROWSER_STORAGE_SET_VALUE: 'browserStorage.setValue',
  CLOUDINARY_UPLOAD: 'cloudinary.upload',
  ELK_LAYOUT: 'elk.layout',
  FAMILY_TREE_COMPUTE_LAYOUT: 'familyTree.computeLayout',
  INVITATION_CREATE_PROGRAMMATIC_USER: 'invitation.createProgrammaticUser',
  INVITATION_LOGIN_REDIRECT: 'invitation.loginRedirect',
  INVITATION_RESEND: 'invitation.resend',
  INVITATION_RESPONSE: 'invitation.respondToInvitation',
  INVITATION_SEND: 'invitation.send',
  LOGOUT_CLEAR_COOKIE: 'logout.clearCookie',
  MDI_HANDLE_POST_MESSAGE: 'mdi.handlePostMessage',
  MDI_UPDATE_ONBOARDING_COMPLETED: 'mdi.updateOnboardingCompleted',
  MDI_UPDATE_ONBOARDING_STARTED: 'mdi.updateOnboardingStarted',
} as const;

export const SENTRY_TAGS = {
  ERROR_BOUNDARY: 'errorBoundary',
  OPERATION: 'operation',
} as const;

export const SENTRY_LEVELS = {
  INFO: 'info',
  ERROR: 'error',
  WARNING: 'warning',
  DEBUG: 'debug',
} as const;

export const SENTRY_BREADCRUMBS = {
  ERROR_BOUNDARY: 'errorBoundary',
  MDI_IFRAME: 'mdi.iframe',
} as const;

export const ERROR_BOUNDARIES = {
  ROUTER_ERROR_PAGE: 'RouterErrorPage',
  FAMILY_TREE_ERROR_BOUNDARY: 'FamilyTreeErrorBoundary',
} as const;

/**
 * Centralized route paths for the entire application.
 * Use these constants instead of hardcoded route strings to ensure type safety
 * and maintain a single source of truth for all routes.
 */
export const ROUTES = {
  LOGIN: '/',
  AUTH_CALLBACK: '/auth-callback',
  CONSENT: '/consent',
  INVITATION: '/invitation/:token',
  ONBOARDING: {
    ROOT: '/onboarding',
    CONSENT: '/onboarding/consent',
    QUESTIONS: '/onboarding/questions',
    RESULTS: '/onboarding/results',
  },
  TREE: '/tree',
  VAULT: '/vault',
  VAULT_NEW: '/vault/new',
  VAULT_EDIT: '/vault/edit/:id',
  NOT_FOUND: '*',
} as const;
